import { skipToken } from '@reduxjs/toolkit/query'

import {
  IQRAGraphCsvExportParams,
  IQRARiskByCategoryGraphApiResult,
  IQRARiskBySystemGraphApiResult
} from '_/src/app/services/api/qra/graphs'
import { useGetQRAAssessmentQuery } from 'app/services/api/qra/assessments'

import {
  IGraphLoadingByType,
  IQRAChartObjects,
  IQRARiskForecastChartObject,
  QRAGraphType
} from '../../Components/Graphs'
import GraphsView from '../../Components/Graphs/Layout/SystemView'

interface GraphsViewWrapperProps {
  showLoading: boolean
  charts?: IQRAChartObjects
  riskByPipelineLengthGraphData?: IQRARiskByCategoryGraphApiResult
  riskBySystemGraphData?: IQRARiskBySystemGraphApiResult
  hasLineViewNavigation: boolean
  qraBasePath: string
  qraViewBasePath: string
  assessmentId?: string
  graphLoadingByType?: IGraphLoadingByType
  csvExportParams?: IQRAGraphCsvExportParams
}

const GraphsViewWrapper = ({
  showLoading,
  charts = {},
  riskByPipelineLengthGraphData,
  riskBySystemGraphData,
  hasLineViewNavigation,
  qraBasePath,
  qraViewBasePath,
  assessmentId,
  graphLoadingByType,
  csvExportParams
}: GraphsViewWrapperProps) => {
  const { currentAssessment } = useGetQRAAssessmentQuery(
    assessmentId ?? skipToken,
    {
      selectFromResult: (result) => ({
        currentAssessment: result.currentData
      })
    }
  )

  const getRiskForecastItems = () => {
    const chartObject = charts[QRAGraphType.RISK_FORECAST]
    const riskForecastChartObject = chartObject as IQRARiskForecastChartObject

    if (currentAssessment) {
      return riskForecastChartObject?.items.filter(
        (item) => item.year >= currentAssessment.fromForecastYear
      )
    }
  }

  const itemsFromGraphType = {
    [QRAGraphType.RISK_FORECAST]: getRiskForecastItems
  }

  return (
    <GraphsView
      qraBasePath={qraBasePath}
      qraViewBasePath={qraViewBasePath}
      showLoading={showLoading}
      charts={charts}
      riskByPipelineLengthGraphData={riskByPipelineLengthGraphData}
      riskBySystemGraphData={riskBySystemGraphData}
      hasLineViewNavigation={hasLineViewNavigation}
      itemsFromGraphType={currentAssessment && itemsFromGraphType}
      graphLoadingByType={graphLoadingByType}
      csvExportParams={csvExportParams}
    />
  )
}

export default GraphsViewWrapper
